import Home from './Home'
import About from './About'
import Teacher from './Tealist'
import Header from './Header'
import examGuidance from './examGuidance'

const Api = {
  Home,
  About,
  Teacher,
  Header,
  examGuidance
}

// 导出
export default Api
